import { c as _c } from "react/compiler-runtime";
import { ScrollableContainer } from '../../../../components/scrollable-container/scrollable-container';
import { Table } from '../../../../components/table/table';
import { type MembershipRequirementBlockByYearData } from '../../../../utils/data/get-membership-requirement-block-by-year';
import { MembershipLevel } from '../../../../utils/enums/membership';
import { type MembershipRequirementsPerYear } from '../../../../utils/types/membership-requirements';
import { type MembershipRequirementsBlockWithFallbacks } from '../../utils/helpers/add-fallbacks-to-membership-requirements-block';
import { useDataFieldRenderer } from '../../utils/hooks/use-data-field-renderer';
import { AdditionalRequirements } from '../additional-requirements/additional-requirements';
import { ContactsBlock } from '../contacts-block/contacts-block';
import { MembershipLevelLabel } from '../membership-level-label/membership-level-label';
import styles from './production-requirements.module.scss';
type ProductionRequirementsProps = {
  blockData: MembershipRequirementsBlockWithFallbacks;
  countryYearData?: MembershipRequirementsPerYear;
  error: Error | null;
  isFetching: boolean;
  yearBlockData?: MembershipRequirementBlockByYearData;
};
export const ProductionRequirements = t0 => {
  const $ = _c(22);
  const {
    blockData,
    countryYearData,
    error,
    isFetching,
    yearBlockData
  } = t0;
  let t1;
  if ($[0] !== countryYearData || $[1] !== isFetching) {
    t1 = {
      countryYearData,
      isFetching
    };
    $[0] = countryYearData;
    $[1] = isFetching;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    renderDataField
  } = useDataFieldRenderer(t1);
  let t2;
  if ($[3] !== blockData || $[4] !== countryYearData || $[5] !== error) {
    t2 = () => {
      if (!countryYearData) {
        return blockData.NoRequirementsLabel ?? "";
      } else {
        if (error) {
          return blockData.ProductionApiErrorLabel ?? "";
        }
      }
      return "";
    };
    $[3] = blockData;
    $[4] = countryYearData;
    $[5] = error;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const noResultsMessage = t2;
  let t3;
  if ($[7] !== blockData || $[8] !== countryYearData || $[9] !== error || $[10] !== isFetching || $[11] !== noResultsMessage || $[12] !== renderDataField) {
    t3 = !isFetching && (!countryYearData || error) ? <div className={styles["note-wrapper"]}><div className={styles["error-message"]}>{noResultsMessage()}</div><ContactsBlock blockData={blockData} /></div> : <ScrollableContainer className={styles.container}><Table className={styles["production-table"]} tabIndex={0}><thead><tr><th className={styles["production-table--sticky"]} scope="col">{blockData.MembershipTableName}</th><th scope="col"><MembershipLevelLabel label={blockData.MembershipTableMemberHeading} membershipLevel={MembershipLevel.MDRT} /></th><th scope="col"><MembershipLevelLabel label={blockData.MembershipTableCoTHeading} membershipLevel={MembershipLevel.COT} /></th><th scope="col"><MembershipLevelLabel label={blockData.MembershipTableToTHeading} membershipLevel={MembershipLevel.TOT} /></th></tr></thead><tbody><tr><th className={styles["production-table--sticky"]} scope="row">{blockData.MembershipTableCommissionRowHeading}</th><td>{renderDataField(countryYearData?.mdrtCommission)}</td><td>{renderDataField(countryYearData?.coTCommission)}</td><td>{renderDataField(countryYearData?.toTCommission)}</td></tr><tr><th className={styles["production-table--sticky"]} scope="row">{blockData.MembershipTableIncomeRowHeading}</th><td>{renderDataField(countryYearData?.mdrtIncome)}</td><td>{renderDataField(countryYearData?.coTIncome)}</td><td>{renderDataField(countryYearData?.toTIncome)}</td></tr><tr><th className={styles["production-table--sticky"]} scope="row">{blockData.MembershipTablePremiumRowHeading}</th><td>{renderDataField(countryYearData?.mdrtPremium)}</td><td>{renderDataField(countryYearData?.coTPremium)}</td><td>{renderDataField(countryYearData?.toTPremium)}</td></tr></tbody></Table></ScrollableContainer>;
    $[7] = blockData;
    $[8] = countryYearData;
    $[9] = error;
    $[10] = isFetching;
    $[11] = noResultsMessage;
    $[12] = renderDataField;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== blockData || $[15] !== countryYearData || $[16] !== isFetching || $[17] !== yearBlockData) {
    t4 = <AdditionalRequirements blockData={blockData} countryYearData={countryYearData} isFetching={isFetching} yearBlockData={yearBlockData} />;
    $[14] = blockData;
    $[15] = countryYearData;
    $[16] = isFetching;
    $[17] = yearBlockData;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  let t5;
  if ($[19] !== t3 || $[20] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  return t5;
};